// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-news-feed-item-content-post .NewsfeedPostContentTitle {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 10px;
}
.fi-news-feed-item-content-post .NewsfeedPostContentText {
  line-height: 20px;
}
.fi-news-feed-item-content-post .NewsfeedPostContentText span {
  font-size: 16px !important;
}
.fi-news-feed-item-content-post .fi-news-feed-item-content-post-rollup-btn {
  margin-top: 12px;
}`, "",{"version":3,"sources":["webpack://./Source/app/news-feed/news-feed-item-content/news-feed-item-content-post/news-feed-item-content-post.component.scss"],"names":[],"mappings":"AACI;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAEI;EACI,iBAAA;AAAR;AACQ;EACI,0BAAA;AACZ;AAEI;EACI,gBAAA;AAAR","sourcesContent":[".fi-news-feed-item-content-post {\r\n    .NewsfeedPostContentTitle {\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        margin-bottom: 10px;\r\n    }\r\n    .NewsfeedPostContentText {\r\n        line-height: 20px;\r\n        span {\r\n            font-size: 16px !important;\r\n        }\r\n    }\r\n    .fi-news-feed-item-content-post-rollup-btn {\r\n        margin-top: 12px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
